import { validateDateNotInFuture } from '../../../utils/validators';
import { NO_EMPLOYER_INFO_STATUSES } from './constants';

const buildCurrentEmployerSection = ({ isFinanciallyResponsible }) => {
  return {
    name: 'currentEmployer',
    title: "APPLICANT'S CURRENT EMPLOYER",
    container: 'collapse',
    GridProps: { xs: 12, marginTop: 2 },
    watchFields: ['employmentStatus'],
    hidden: ({ getValues }) => !getValues('employmentStatus'),
    collapsed: ({ getValues }) =>
      NO_EMPLOYER_INFO_STATUSES.includes(getValues('employmentStatus')),
    disabled: ({ getValues }) =>
      NO_EMPLOYER_INFO_STATUSES.includes(getValues('employmentStatus')),
    fields: [
      ...(isFinanciallyResponsible
        ? [
            {
              variant: 'text',
              name: 'currentJobPosition',
              label: 'Position',
              rules: {
                required: true,
              },
              GridProps: { xs: 12, sm: 4 },
            },
          ]
        : []),
      {
        variant: 'currency',
        name: 'currentJobAnnualSalary',
        label: 'Annual Income',
        GridProps: { xs: 12, sm: 3 },
        rules: {
          required: true,
          min: 0.01,
        },
      },
      ...(isFinanciallyResponsible
        ? [
            {
              variant: 'date',
              name: 'currentJobStartDate',
              label: 'Start Date',
              GridProps: { xs: 12, sm: 2 },
              rules: {
                required: true,
                validate: (value) => {
                  return validateDateNotInFuture(value, 'Start Date');
                },
              },
            },
            {
              variant: 'flexSpacer',
            },
            {
              variant: 'text',
              name: 'currentJobEmployerName',
              label: 'Employer Name',
              GridProps: { xs: 12, sm: 4 },
              rules: {
                required: true,
              },
            },
            {
              variant: 'phone',
              name: 'currentJobEmployerPhone',
              label: 'Employer Phone',
              GridProps: { xs: 12, sm: 3 },
              rules: {
                required: true,
              },
            },
            {
              variant: 'text',
              name: 'currentJobSupervisorName',
              label: 'Supervisor Name',
              GridProps: { xs: 12, sm: 4 },
              rules: {
                required: true,
              },
            },
            {
              variant: 'flexSpacer',
            },
            {
              variant: 'text',
              name: 'currentJobStreetAddress',
              label: 'Employer Street Address',
              GridProps: { xs: 12, sm: 4 },
              rules: {
                required: true,
              },
            },
            {
              variant: 'text',
              name: 'currentJobCity',
              label: 'City',
              GridProps: { xs: 12, sm: 3 },
              rules: {
                required: true,
              },
            },
            {
              variant: 'singleSelect',
              name: 'currentJobState',
              label: 'State/Province',
              GridProps: { xs: 12, sm: 3 },
              rules: {
                required: true,
              },
            },
            {
              variant: 'text',
              name: 'currentJobZipCode',
              label: 'Zip Code/Postal Code',
              GridProps: { xs: 12, sm: 2 },
              rules: {
                required: true,
              },
            },
          ]
        : []),
    ],
  };
};

export default buildCurrentEmployerSection;
